import React from 'react';

export const EllipseIcon = ({ className }) => (
  <svg
    className={className}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle id="Ellipse" cx="5" cy="5" r="4.5" fill="#EB2F96" stroke="white" />
  </svg>
);
